module.exports = __webpack_public_path__ + "img/game_main_pc_204_off.7209877c.png";